import { z } from 'zod';

const day = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/)
  .refine((value) => {
    const parsed = new Date(`${value}T00:00:00Z`);
    return Number.isFinite(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
  });
export const searchFormSchema = z.object({
  origin: z.string().regex(/^[A-Z]{3}$/),
  destination: z.string().regex(/^[A-Z]{3}$/),
  departureDate: day,
  currency: z.string().regex(/^[A-Z]{3}$/),
  passengers: z
    .array(z.object({ id: z.string().min(1), age: z.number().int().min(0).max(120) }))
    .min(1)
    .max(9),
});
export type SearchForm = z.infer<typeof searchFormSchema>;

export const travelerFormSchema = z.object({
  travelers: z
    .array(
      z
        .object({
          id: z.string().min(1),
          givenName: z.string().trim().min(1),
          familyName: z.string().trim().min(1),
          bornOn: day,
          gender: z.enum(['m', 'f']),
          title: z.enum(['mr', 'ms', 'mrs', 'miss', 'dr']),
          email: z.email(),
          phoneNumber: z.string().regex(/^\+[1-9]\d{6,14}$/),
          nationality: z.string().regex(/^([A-Z]{2})?$/),
          passportNumber: z.string(),
          passportExpiry: z.string(),
          passportCountry: z.string().regex(/^([A-Z]{2})?$/),
          infantPassengerId: z.string(),
        })
        .superRefine((person, context) => {
          if (person.passportNumber || person.passportExpiry || person.passportCountry) {
            if (
              !person.passportNumber.trim() ||
              !day.safeParse(person.passportExpiry).success ||
              !/^[A-Z]{2}$/.test(person.passportCountry)
            ) {
              context.addIssue({
                code: 'custom',
                message: 'INCOMPLETE_PASSPORT',
                path: ['passportNumber'],
              });
            }
          }
        }),
    )
    .min(1)
    .max(9),
});
export type TravelerForm = z.infer<typeof travelerFormSchema>;

export function ageOn(bornOn: string, departureDate: string): number {
  const born = new Date(`${bornOn}T00:00:00Z`);
  const flight = new Date(`${departureDate}T00:00:00Z`);
  let age = flight.getUTCFullYear() - born.getUTCFullYear();
  if (departureDate.slice(5) < bornOn.slice(5)) age--;
  return age;
}
